<template>
  <div class="the-car-configurator">
    <h1>Werkstatt</h1>
    <div v-if="mode == 'car'">
      <h2>Wähle dein Auto</h2>
      <div class="car-select-container select">
        <div
          :class="[car == 'starter' ? 'active' : '', 'car tile']"
          @click="car = 'starter'"
        >
          <Starter />
        </div>
        <div
          :class="[car == 'coupe' ? 'active' : '', 'car tile']"
          @click="car = 'coupe'"
        >
          <Coupe />
        </div>
        <div
          :class="[car == 'truck' ? 'active' : '', 'car tile']"
          @click="car = 'truck'"
        >
          <Truck />
        </div>
        <div
          :class="[car == 'city' ? 'active' : '', 'car tile']"
          @click="car = 'city'"
        >
          <City />
        </div>
        <div
          :class="[car == 'cabrio' ? 'active' : '', 'car tile']"
          @click="car = 'cabrio'"
        >
          <Cabrio />
        </div>
        <div
          :class="[car == 'racer' ? 'active' : '', 'car tile']"
          @click="car = 'racer'"
        >
          <Racer />
        </div>
      </div>
    </div>
    <div v-if="mode == 'rims'">
      <h2>Felgen</h2>
      <div class="rim-select-container select">
        <div
          v-for="r in [1, 2]"
          :key="r"
          :class="[rims == r ? 'active' : '', 'rim tile']"
          @click="rims = r"
        >
          Typ {{ r }}
        </div>
      </div>
    </div>
    <div v-if="mode == 'color'">
      <h2>Farbe</h2>
      <div class="color-select-container select">
        <div
          v-for="c in ['gray', 'black', 'pink', 'green', 'yellow', 'blue']"
          :key="c"
          :class="[color == c ? 'active' : '', 'color tile', c]"
          @click="color = c"
        ></div>
      </div>
    </div>
    <div v-if="mode == 'eco'">
      <h2>ECO Modus</h2>
      <div class="eco-select-container select">
        <div :class="[!eco ? 'active' : '', 'eco tile']" @click="eco = false">
          OFF
        </div>
        <div :class="[eco ? 'active' : '', 'eco tile']" @click="eco = true">
          ON
        </div>
      </div>
    </div>
    <div v-if="mode == 'charm'">
      <h2>Glücksbringer</h2>
      <div class="charm-select-container select">
        <div
          :class="[charm == 'hoof' ? 'active' : '', 'charm tile']"
          @click="charm = 'hoof'"
        >
          <Hoof />
        </div>
        <div
          :class="[charm == 'chimney' ? 'active' : '', 'charm tile']"
          @click="charm = 'chimney'"
        >
          <Chimney />
        </div>
        <div
          :class="[charm == 'beetle' ? 'active' : '', 'charm tile']"
          @click="charm = 'beetle'"
        >
          <Beetle />
        </div>
        <div
          :class="[charm == 'clover' ? 'active' : '', 'charm tile']"
          @click="charm = 'clover'"
        >
          <Clover />
        </div>
        <div
          :class="[charm == 'pig' ? 'active' : '', 'charm tile']"
          @click="charm = 'pig'"
        >
          <Pig />
        </div>
        <div
          :class="[charm == 'mushroom' ? 'active' : '', 'charm tile']"
          @click="charm = 'mushroom'"
        >
          <Mushroom />
        </div>
      </div>
    </div>
    <div v-if="mode == 'windows'">
      <h2>Fenster</h2>
      <div class="windows-select-container select">
        <div
          v-for="w in ['hell', 'dunkel']"
          :key="w"
          :class="[w == windows ? 'active' : '', w, 'window tile']"
          @click="windows = w"
        ></div>
      </div>
    </div>
    <div class="button-container">
      <BaseButton @click="save">Speichern</BaseButton>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "@/http";
import qs from "qs";

import Starter from "@/components/CarStarter";
import Coupe from "@/components/CarCoupe";
import Truck from "@/components/CarTruck";
import City from "@/components/CarCity";
import Cabrio from "@/components/CarCabrio";
import Racer from "@/components/CarRacer";

import Hoof from "@/components/CharmHoof";
import Mushroom from "@/components/CharmMushroom";
import Chimney from "@/components/CharmChimney";
import Pig from "@/components/CharmPig";
import Eco from "@/components/CharmEco";
import Beetle from "@/components/CharmBeetle";
import Clover from "@/components/CharmClover";

import BaseButton from "@/components/BaseButton";

export default {
  name: "TheCarConfigurator",
  components: {
    Starter,
    Coupe,
    Truck,
    City,
    Cabrio,
    Racer,
    Hoof,
    Mushroom,
    Chimney,
    Pig,
    Beetle,
    Eco,
    Clover,
    BaseButton,
  },
  props: {
    mode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      car: null,
      color: null,
      rims: null,
      charm: null,
      windows: null,
      eco: false,
    };
  },
  mounted() {
    if (this.myCar) {
      this.car = this.myCar.car;
      this.color = this.myCar.color;
      this.rims = this.myCar.rims;
      this.windows = this.myCar.windows;
      this.charm = this.myCar.charm;
      this.eco = this.myCar.eco;
    }
  },
  computed: {
    ...mapGetters(["myCar", "tokenHeader"]),
  },
  methods: {
    async save() {
      try {
        let car = {
          car: this.car,
          color: this.color,
          rims: this.rims,
          windows: this.windows,
          charm: this.charm,
          eco: this.eco,
        };
        let postData = qs.stringify(car);
        let result = await axios.post(
          process.env.VUE_APP_FLL_ROOT_API + "/me/meta/car",
          postData,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              ...this.tokenHeader,
            },
          }
        );
        this.setMyCar(car);
        this.setConfigureCar(false);
      } catch (error) {
        // TODO: handle error
        console.error(error); // eslint-disable-line
      }
    },
    ...mapActions([
      "setCar",
      "setColor",
      "setRims",
      "setWindows",
      "setCharm",
      "setConfigureCar",
      "setMyCar",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.the-car-configurator {
  h1 {
    font-size: 18px;
    color: $green;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 16px;
    color: $green;
    margin: 20px 0 5px 0;
    text-align: center;
    /*border-bottom: 1px solid $green;*/
  }

  .select {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .tile {
      border: 2px solid #aeaeae;
      &:hover {
        cursor: pointer;
        border: 2px solid $blue;
      }

      &.active {
        border: 2px solid $blue;
      }
    }

    &.rim-select-container,
    &.eco-select-container {
      justify-content: space-around;

      .tile {
        width: 55px;
        height: 55px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
      }
    }

    .car {
      width: 47%;
      border: 2px solid transparent;
      margin-bottom: 10px;

      svg {
        width: 100%;
        height: auto;
      }
    }

    .color {
      width: 30px;
      height: 30px;
      cursor: pointer;

      &.gray {
        background: #9b9b9e;
      }
      &.black {
        background: black;
      }
      &.green {
        background: #8db335;
      }
      &.pink {
        background: #992868;
      }
      &.blue {
        background: #3c6d9c;
      }
      &.yellow {
        background: #e7b012;
      }
    }

    .charm {
      padding: 5px;
      border: 2px solid transparent;
    }

    &.windows-select-container {
      justify-content: space-around;

      .window {
        width: 50px;
        height: 50px;

        &.active {
          border: 2px solid $blue;
        }

        &.hell {
          background: #eaeaea;
        }

        &.dunkel {
          background: #2f2f2f;
        }
      }

      .tile {
        &:hover,
        &.active {
          cursor: pointer;
          border: 2px solid $blue;
        }
      }
    }
  }

  .button-container {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
}
</style>
